export default "__VITE_ASSET__kpLS25DZ__"